var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithUsList5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.875H17.5",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.875V9.375C2.5 4.375 3.75 3.125 8.75 3.125",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.875V9.375C27.5 4.375 26.25 3.125 21.25 3.125",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.8877V24.0002C12.5 26.5002 11.5 27.5002 9 27.5002H6C3.5 27.5002 2.5 26.5002 2.5 24.0002V19.8877C2.5 17.3877 3.5 16.3877 6 16.3877H9C11.5 16.3877 12.5 17.3877 12.5 19.8877Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 19.8877V24.0002C27.5 26.5002 26.5 27.5002 24 27.5002H21C18.5 27.5002 17.5 26.5002 17.5 24.0002V19.8877C17.5 17.3877 18.5 16.3877 21 16.3877H24C26.5 16.3877 27.5 17.3877 27.5 19.8877Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithUsList5);
export default __webpack_public_path__ + "static/media/chatWithUsList5.5a74b81aba072dd7f02fc9a490e3ce90.svg";
export { ForwardRef as ReactComponent };